import { render, staticRenderFns } from "./EchartsPie.vue?vue&type=template&id=54faff9a&scoped=true"
import script from "./EchartsPie.vue?vue&type=script&lang=js"
export * from "./EchartsPie.vue?vue&type=script&lang=js"
import style0 from "./EchartsPie.vue?vue&type=style&index=0&id=54faff9a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54faff9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54faff9a')) {
      api.createRecord('54faff9a', component.options)
    } else {
      api.reload('54faff9a', component.options)
    }
    module.hot.accept("./EchartsPie.vue?vue&type=template&id=54faff9a&scoped=true", function () {
      api.rerender('54faff9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/confirmation/Components/EchartsPie.vue"
export default component.exports